<template>
  <div class="h-full overflow-x-hidden">
    <div v-if="appointment" class="h-full">
      <div>
        <AppointmentStatusDropdown
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
        />
      </div>
      <div>
        <AppointmentServiceCategory
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
        />
        <NavTab :tabs="tabs" variant="default" />
      </div>
      <div class="py-4 px-8 bg-gray-50 -mx-4 h-full">
        <component
          :is="tabComponent"
          :appointment="appointment"
          @refresh-appointment="fetchAppointment"
          @request-save="onRequestSave"
        />
        <RescheduleNotifyModal
          v-if="pendingSave"
          :pending-payload="pendingSave.payload"
          :action-name="pendingSave.action"
          @hide-modal="onModalClose"
        />
      </div>
    </div>
    <div v-else class="h-full flex items-center justify-center">
      <Spinner />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import cable from "@/lib/cable.js";
import { EventBus } from "@/lib/event_bus";

import NavTab from "@/components/Seranova/NavTab/NavTab.vue";
import Spinner from "@/components/Seranova/Spinner/Spinner.vue";
import VueChannel from "@/channels/VueChannel";
import RescheduleNotifyModal from "@/Scheduler/RescheduleNotifyModal.vue";
import { AppointmentV2 } from "@/typings/appointment";
import AppointmentDetailsTab from "./AppointmentDetailsTab.vue";
import AppointmentServiceCategory from "./AppointmentServiceCategory.vue";
import AppointmentStatusDropdown from "./AppointmentStatusDropdown.vue";
const emit = defineEmits(["appointment-change"]);
const props = defineProps<{ appointmentId: string | number }>();
const appointment = ref<AppointmentV2 | null>(null);
const pendingSave = ref<{ action: string; payload: object } | null>(null);

const store = useStore();
const activeTab = ref("Details");

const tabs = computed(() => {
  return [{ label: "Details", active: true }];
});

const tabComponent = computed(() => {
  switch (activeTab.value) {
    default:
      return AppointmentDetailsTab;
  }
});

let vueChannel: VueChannel | null = null;

const handleAppointmentUpdated = (data: { id: number }) => {
  if (String(data.id) === String(props.appointmentId)) {
    fetchAppointment();
  }
};

onMounted(() => {
  fetchAppointment();
  EventBus.$on("appointment-updated", handleAppointmentUpdated);

  vueChannel = new VueChannel();
  cable.subscribe(vueChannel).catch((err) => {
    console.log("Unable to subscribe to VueChannel", err);
  });
});

onBeforeUnmount(() => {
  EventBus.$off("appointment-updated", handleAppointmentUpdated);
  vueChannel?.disconnect();
});

const fetchAppointment = async () => {
  appointment.value = await store.dispatch("fetchAppointmentDetails", {
    id: props.appointmentId
  });
  emit("appointment-change", appointment.value);
};

const onRequestSave = (data: { action: string; payload: object }) => {
  pendingSave.value = data;
};

const onModalClose = () => {
  pendingSave.value = null;
  fetchAppointment();
};
</script>

<style></style>
